import NumberFormat from 'react-number-format';
import { useSalesHistoryOfferAuction } from '../hooks';

export const LastVehicleOffer = ({ vehicle }) => {
  const amount = useVehicleLastOffer(vehicle);
  if (!amount) {
    return 'N/A';
  }
  return <NumberFormat displayType="text" prefix="$" value={amount} thousandSeparator />;
};

const useVehicleLastOffer = vehicle => {
  const offerAuction = useSalesHistoryOfferAuction(vehicle.id);

  if (vehicle.top_alternative_bid_offer) {
    return vehicle.top_alternative_bid_offer.amount;
  }

  const lastOffer = offerAuction?.offerBids?.[0];
  if (lastOffer) {
    return lastOffer?.amount;
  }

  const lastBid = vehicle.bids?.[0];

  return lastBid?.amount || null;
};
